export enum UniTagType {
  default = 'default',
  active = 'active',
  ghost = 'ghost',
}
